import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Badge } from '../ui/badge';
import { motion } from 'framer-motion';

export const CategoryChip = ({ category, productsCount }) => {
  const FALLBACK_IMAGE = 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%20width%3D%27128%27%20height%3D%27128%27%3E%0A%3Crect%20width%3D%27100%25%27%20height%3D%27100%25%27%20fill%3D%27%23eee%27/%3E%0A%3Ctext%20x%3D%2750%25%27%20y%3D%2750%25%27%20dominant-baseline%3D%27middle%27%20text-anchor%3D%27middle%27%20fill%3D%27%23777%27%20font-family%3D%27Arial%27%20font-size%3D%2712%27%3ENo%20Image%3C/text%3E%0A%3C/svg%3E';
  const sampleImage = category.image_url || category.image || FALLBACK_IMAGE;
  
  return (
    <Link to={`/shop?category=${category.id}`}>
      <motion.div
        whileHover={{ scale: 1.02 }}
        className="flex-shrink-0 w-32 group cursor-pointer"
      >
        <div className="relative aspect-square rounded-xl overflow-hidden mb-2 border-2 border-transparent group-hover:border-primary transition-smooth">
          <img
            src={sampleImage}
            alt={category.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-smooth" />
          {productsCount > 0 && (
            <Badge 
              variant="default" 
              className="absolute bottom-2 right-2 text-xs"
            >
              {productsCount}
            </Badge>
          )}
        </div>
        <p className="text-sm font-medium text-center line-clamp-2 group-hover:text-primary transition-smooth">
          {category.name}
        </p>
      </motion.div>
    </Link>
  );
};